import { Root } from '@radix-ui/react-radio-group';
import type { CSSProperties, FunctionComponent, ReactNode } from 'react';

import { mergeClassNames } from '../../utils/tailwind-merge';

export type RadioGroupProps = {
    readonly children: ReactNode;
    readonly className?: string;
    readonly defaultValue?: string;
    readonly name?: string;
    readonly onValueChange?: (value: string) => void;
    readonly style?: CSSProperties;
    readonly value?: string;
};

export const RadioGroup: FunctionComponent<RadioGroupProps> = ({
    children,
    className,
    defaultValue,
    name,
    onValueChange,
    value,
    ...props
}) => {
    return (
        <Root
            className={mergeClassNames('flex flex-col gap-m', className)}
            defaultValue={defaultValue}
            name={name}
            value={value}
            onValueChange={onValueChange}
            {...props}
        >
            {children}
        </Root>
    );
};

export { RadioButton } from './RadioButton';
export type { RadioGroupItemProps } from './RadioGroupItem';
export { RadioGroupItem } from './RadioGroupItem';
